import "./embedded-map.css";
import { jsxs as d, jsx as n } from "react/jsx-runtime";
import { Paragraph as l } from "@pathccm/rula-ui/typography";
import g from "@pathccm/rula-ui/link";
const b = "_embeddedMap_sr6ny_26", h = "_container_sr6ny_32", w = "_textContainer_sr6ny_40", t = {
  embeddedMap: b,
  container: h,
  textContainer: w
}, M = ({
  apiKey: i,
  location: r,
  directionsFrom: s,
  width: o = 340,
  height: c = 195
}) => {
  const m = () => {
    const e = "https://www.google.com/maps/embed/v1/search", a = new URLSearchParams({
      key: i,
      q: r
    });
    return `${e}?${a.toString()}`;
  }, p = () => {
    const e = new URLSearchParams({ api: "1" });
    let a;
    return s ? (a = "dir", e.append("origin", s), e.append("destination", r)) : (a = "search", e.append("query", r)), `${`https://www.google.com/maps/${a}/`}?${e.toString()}`;
  };
  return /* @__PURE__ */ d("div", { className: t.container, style: { width: `${o}px` }, children: [
    /* @__PURE__ */ n(
      "iframe",
      {
        className: t.embeddedMap,
        title: "Embedded Map",
        "aria-label": "Interactive map",
        width: o,
        height: c,
        loading: "lazy",
        allowFullScreen: !1,
        referrerPolicy: "no-referrer-when-downgrade",
        allow: "geolocation: none;",
        src: m()
      }
    ),
    /* @__PURE__ */ d("div", { className: t.textContainer, children: [
      /* @__PURE__ */ n("p", { style: l, children: r }),
      /* @__PURE__ */ n(g, { size: "large", href: p(), target: "_blank", children: "View map →" })
    ] })
  ] });
};
export {
  M as E
};
